import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommendSection from './components/HotRecommendSection';
import LatestUpdateSection from './components/LatestUpdateSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = '蜜桃少年漫画_漫画大结局免费阅读_89890漫画网';

    const existing = document.getElementById('schema-homepage');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'schema-homepage';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '蜜桃少年漫画 - 89890漫画网首页',
      description: '89890漫画网首页，提供蜜桃少年漫画大结局免费在线阅读，海量高清漫画每日更新。',
      url: 'https://www.89890.com',
      isPartOf: {
        '@type': 'WebSite',
        name: '89890漫画网',
        url: 'https://www.89890.com',
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: 'https://www.89890.com',
          },
        ],
      },
    });
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-homepage');
      if (s) s.remove();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommendSection />
        <LatestUpdateSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}